import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import ChevronLeftIcon from '../../components/icons/ChevronLeftIcon'

const BackLinkContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 0;
`

const BackLink = styled.a`
  display: flex;
  font-size: 0.75rem;
  color: #1454b8;
  align-items: center;
  padding: 0.25rem 0;
  text-decoration: none;
`

const BackIcon = styled(ChevronLeftIcon)`
  margin-right: 0.5rem;
`

const RecipeHomeBackLink = () => {
  return (
    <BackLinkContainer>
      <Link passHref href={'/recipes'}>
        <BackLink>
          <BackIcon />
          <p>Back to recipes</p>
        </BackLink>
      </Link>
    </BackLinkContainer>
  )
}

export default RecipeHomeBackLink
